import React from 'react';

export const getTransactionHeaderType = (ticketNumber) => {
  const ticket = String(ticketNumber || '');

  if (ticket.includes('OUT')) return 'Invoice';
  if (ticket.includes('CHK')) return 'Purchase Order';
  if (ticket.includes('RES')) return 'Reserve';
  if (ticket.includes('ADJ')) return 'Adjustment';
  if (ticket.includes('RET')) return 'Return';

  return 'Transaction';
};

const headerFieldStyle = {
  margin: '2px 24px 2px 0',
  whiteSpace: 'nowrap',
};

const TransactionHeader = ({
  ticketNumber,
  recipientName,
  date,
  userName,
  brokers = [],
  showBrokers = false,
}) => {
  const transactionType = getTransactionHeaderType(ticketNumber);
  const populatedBrokers = showBrokers
    ? brokers.filter((broker) => broker && broker.name)
    : [];

  return (
    <div
      className="transaction-print-header"
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'baseline',
        margin: '2px 0 12px',
      }}
    >
      <span style={headerFieldStyle}>
        <b>To:</b> {recipientName || ''}
      </span>
      <span style={headerFieldStyle}>
        <b>{transactionType}:</b> {ticketNumber || ''}
      </span>
      <span style={headerFieldStyle}>
        {date || ''} <b>by:</b> {userName || ''}
      </span>
      {populatedBrokers.map((broker) => (
        <span key={broker.number} style={headerFieldStyle}>
          <b>{`Broker #${broker.number}:`}</b> {broker.name}
        </span>
      ))}
    </div>
  );
};

export default TransactionHeader;
